import { DisplayTime } from 'common/display-state/display-time.js';
import { WARNING_BASE_MARINE } from 'components/navigation/config.js';
import { IWarning } from 'redux-state/weather-warnings/types.js';
import { regionTitleCase } from 'utilities/text/titleCase.js';
import { buildDataSlug } from 'utilities/weather-warnings/warnings.js';
import { WarningBarAddAsLink } from './utils/redirect-to-url.js';

type IPanelBodyMarineListSubType = {
  warnings: IWarning[];
  issuedAt: string;
  nextIssuedAt: string;
};

export const PanelBodyMarineListSubType = ({ warnings, issuedAt, nextIssuedAt }: IPanelBodyMarineListSubType) => {
  if (warnings.length) {
    const elements = warnings.map((w) => {
      return (
        <div data-module="PanelBodyMarineListSubType" key={`${w.regions?.[0] ?? ''}`}>
          <WarningBarAddAsLink
            classes={'hover-blue negative-margin border-radius-xs u-block u-mT-xs'}
            link={true}
            url={w.url ?? WARNING_BASE_MARINE}
            key={buildDataSlug(w)}
          >
            <div>
              <h3 className="u-mT-0 u-mB-0 u-inline">Area:&nbsp;</h3>
              <p className="u-inline">{w.areaDescription || regionTitleCase(w.regions ?? [])}</p>
            </div>
          </WarningBarAddAsLink>
        </div>
      );
    });

    return (
      <>
        {elements}
        {issuedAt && (
          <small className="u-textGrey u-mT-xs fineprint u-block">
            <>
              Issued:&nbsp;
              <DisplayTime date={issuedAt} />
            </>
          </small>
        )}
        {nextIssuedAt && (
          <small className="u-textGrey fineprint u-block">
            Next update:&nbsp;
            <DisplayTime date={nextIssuedAt} />
          </small>
        )}
      </>
    );
  }
  return null;
};
